export type RouteMarkerRole = 'origin' | 'waypoints' | 'destination';

export interface RouteMarkerIconOptions {
    /** 0-based index */
    index: number;
    total: number;
    isActive?: boolean;
    locationType: RouteMarkerRole;
}

const ACTIVE_SIZE = 36;
const NORMAL_SIZE = 28;

function markerColors(index: number, total: number): { fill: string; stroke: string; text: string } {
    if (total === 1) {
        return { fill: '#16a34a', stroke: '#15803d', text: '#ffffff' };
    }
    if (index === 0) {
        return { fill: '#16a34a', stroke: '#15803d', text: '#ffffff' };
    }
    if (index === total - 1) {
        return { fill: '#1e293b', stroke: '#0f172a', text: '#ffffff' };
    }
    return { fill: '#ffffff', stroke: '#E31E24', text: '#E31E24' };
}

export function createRouteMarkerIcon(options: RouteMarkerIconOptions): {
    url: string;
    scaledSize: { width: number; height: number };
    anchor: { x: number; y: number };
} {
    const { index, total, isActive = false } = options;
    const size = isActive ? ACTIVE_SIZE : NORMAL_SIZE;
    const radius = isActive ? 13 : 10;
    const cx = size / 2;
    const cy = size / 2;
    const label = String(index + 1);
    const { fill, stroke, text } = markerColors(index, total);

    const svg = `
<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">
  ${isActive ? `<circle cx="${cx}" cy="${cy}" r="${radius + 4}" fill="#E31E24" opacity="0.22"/>` : ''}
  <circle cx="${cx}" cy="${cy}" r="${radius}" fill="${fill}" stroke="${stroke}" stroke-width="2"/>
  <text x="${cx}" y="${cy}" text-anchor="middle" dominant-baseline="central" fill="${text}" font-size="${isActive ? 12 : 10}" font-weight="700" font-family="Inter,Arial,sans-serif">${label}</text>
</svg>`.trim();

    return {
        url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
        scaledSize: { width: size, height: size },
        anchor: { x: cx, y: cy },
    };
}

/** AdvancedMarkerElement içeriği (SVG pin) */
export function createRouteMarkerContent(options: RouteMarkerIconOptions): HTMLImageElement {
    const icon = createRouteMarkerIcon(options);
    const img = document.createElement('img');
    img.src = icon.url;
    img.width = icon.scaledSize.width;
    img.height = icon.scaledSize.height;
    img.alt = '';
    img.draggable = false;
    img.style.display = 'block';
    return img;
}
